
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { APP_CONFIG } from '@/config/app-config';
import cartServices from '@/services/cart-services';
@Component({
  components: {
    Loading
  },
})
export default class MainPayService extends Vue {
    private isLoading = false;
    private searchTerm = '';
    private searchSite = 'TAOBAO';
    private searchResult: any = null;

    get showMenu() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get rate() {
      return this.$store.state[APP_CONFIG.stateKey.commonStore].rate;
    }

    private isMobile() {
      return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }

    private async searchProduct() {
        this.isLoading = true;
        const result = await cartServices.searchProducts(this.searchSite, this.searchTerm, this.isMobile());
        if (result && result.status === 200 && result.data.message === 'Success') {
          (this.$refs.tb_link as any).href = result.data.data.url;
          (this.$refs.tb_link as any).click();
        }
        this.isLoading = false;
    }
}
